import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

// ── Action Context ──────────────────────────────────────────

interface ActionContextValue {
  onAction?: (action: string, meta: Record<string, unknown>, originalEvent: React.MouseEvent) => void;
  activeAction?: string;
}

const ActionContext = createContext<ActionContextValue>({});

export const useActionContext = (): ActionContextValue => useContext(ActionContext);

export const ActionProvider = ({ value, children }: { value: ActionContextValue; children: ReactNode }) => (
  <ActionContext.Provider value={value}>{children}</ActionContext.Provider>
);
